/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Val_TitleInputs */

const en_st_val_title = /** @type {(inputs: St_Val_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three things you stop doing by hand`)
};

const id_st_val_title = /** @type {(inputs: St_Val_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiga hal yang berhenti kamu kerjakan manual`)
};

/**
* | output |
* | --- |
* | "Three things you stop doing by hand" |
*
* @param {St_Val_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_val_title = /** @type {((inputs?: St_Val_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Val_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_val_title(inputs)
	return en_st_val_title(inputs)
});